import { useState } from 'react';
import apiClient from '../utils/api';

interface WeightEntry {
  weight: number;
  unit: 'lbs' | 'kg';
}

export const useWeights = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const createWeight = async (entry: WeightEntry): Promise<boolean> => {
    setLoading(true);
    setError(null);

    try {
      await apiClient.post('/weights', entry);
      return true;
    } catch (err: any) {
      const errorMessage = err.response?.data?.error || 'Failed to save weight. Please try again.';
      setError(errorMessage);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return {
    createWeight,
    loading,
    error,
  };
};
